<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="hero">
        <div class="hero__bg _ibg">
          <img src="./../img/hero-bg.png" />
        </div>
        <div class="hero__line _ibg">
          <img src="./../img/hero-line.png" />
        </div>
        <div class="hero__inner _cnt">
          <div class="hero__content">
            <div class="hero__items">
              <div class="hero__item">
                <div class="hero__box hero__box_green"></div>
                <span>{{ $t('ОНЛАЙН') }}</span>
              </div>
              <div class="hero__item">
                <div class="hero__box"></div>
                <span>JAVA 1.21.11</span>
              </div>
            </div>
            <div class="hero__title _h1">
              {{ $t('Собери свой мир') }}
              <div>
                {{ $t('из') }} <span>{{ $t('кубов') }}</span>
              </div>
            </div>
            <div class="hero__text">
              {{
                $t(
                  'Выживай в диких биомах, строй базы вместе с друзьями и прокачивай персонажа на сервере, где честная игра важнее доната.',
                )
              }}
            </div>
            <div class="hero__actions">
              <button
                type="button"
                class="hero__action hero__action_first button shadowed"
                @click="playNow"
              >
                <span>{{ $t('НАЧАТЬ ИГРУ') }}</span>

                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M0.991669 6.36072H10.9083"
                    stroke="currentColor"
                    stroke-width="1.98333"
                    stroke-linecap="square"
                  />
                  <path
                    d="M5.95001 1.4024L10.9083 6.36074L5.95001 11.3191"
                    stroke="currentColor"
                    stroke-width="1.98333"
                    stroke-linecap="square"
                  />
                </svg>
              </button>
              <button
                type="button"
                class="hero__action button bordered"
                :disabled="!serverAddress"
                @click="copyIP"
              >
                <template v-if="ipCopied">{{ $t('Скопировано') }}</template>
                <template v-else>
                  <span>
                    {{ $t('IP:') }}
                  </span>
                  <span>
                    {{ serverAddress || $t('Загрузка...') }}
                  </span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
                      stroke="currentColor"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />

                    <path
                      d="M3.33333 9.99998H2.66667C2.31305 9.99998 1.97391 9.8595 1.72386 9.60946C1.47381 9.35941 1.33333 9.02027 1.33333 8.66665V2.66665C1.33333 2.31302 1.47381 1.97389 1.72386 1.72384C1.97391 1.47379 2.31305 1.33331 2.66667 1.33331H8.66667C9.02029 1.33331 9.35943 1.47379 9.60948 1.72384C9.85952 1.97389 10 2.31302 10 2.66665V3.33331"
                      stroke="currentColor"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </button>
            </div>
            <div class="hero__stats">
              <div class="hero__stat">
                <div class="hero__label">50K+</div>
                <div class="hero__value">{{ $t('игроков') }}</div>
              </div>
              <div class="hero__stat">
                <div class="hero__label">99.9%</div>
                <div class="hero__value">{{ $t('аптайм') }}</div>
              </div>
              <div class="hero__stat">
                <div class="hero__label">24</div>
                <div class="hero__value">{{ $t('поддержка') }}</div>
              </div>
            </div>
          </div>
          <div class="hero__image _ibg-contain">
            <svg
              width="579"
              height="578"
              viewBox="0 0 579 578"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_3_211"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="56"
                y="32"
                width="476"
                height="476"
              >
                <g clip-path="url(#clip0_3_211)">
                  <path
                    d="M294.41 32.3806H341.894V79.8645H389.378V127.348H436.862V174.832H484.345V222.316H531.829V317.284H484.345V364.768H436.862V412.252H389.378V459.736H341.894V507.219H246.926V459.736H199.442V412.252H151.958V364.768H104.474V317.284H56.9905V222.316H104.474V174.832H151.958V127.348H199.442V79.8645H246.926V32.3806H294.41Z"
                    fill="black"
                  />
                </g>
              </mask>
              <g class="green-bg-block" mask="url(#mask0_3_211)">
                <rect
                  x="56.9905"
                  y="32.3806"
                  width="474.839"
                  height="474.839"
                  fill="url(#paint0_linear_3_211)"
                />
              </g>
              <mask
                id="mask1_3_211"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="127"
                y="102"
                width="335"
                height="336"
              >
                <g clip-path="url(#clip1_3_211)">
                  <path
                    d="M294.41 102.522H327.865V135.978H361.321V169.433H394.777V202.889H428.232V236.344H461.688V303.256H428.232V336.711H394.777V370.167H361.321V403.622H327.865V437.078H260.954V403.622H227.499V370.167H194.043V336.711H160.587V303.256H127.132V236.344H160.587V202.889H194.043V169.433H227.499V135.978H260.954V102.522H294.41Z"
                    fill="black"
                  />
                </g>
              </mask>
              <g mask="url(#mask1_3_211)">
                <rect
                  x="127.132"
                  y="102.522"
                  width="334.556"
                  height="334.556"
                  fill="#21C17E"
                  fill-opacity="0.1"
                />
              </g>
              <g class="yellow-cube" filter="url(#filter0_dii_3_211)">
                <rect
                  width="110"
                  height="110"
                  transform="translate(83.4128 34.3316)"
                  fill="#E4C14A"
                />
                <g filter="url(#filter1_i_3_211)">
                  <rect
                    x="109.413"
                    y="60.3316"
                    width="58"
                    height="58"
                    fill="#F0D886"
                  />
                </g>
              </g>
              <g class="ground-block" filter="url(#filter2_dii_3_211)">
                <rect
                  width="230"
                  height="230"
                  transform="translate(179.413 86.3316)"
                  fill="#6B4A2F"
                />
                <g filter="url(#filter3_ii_3_211)">
                  <rect
                    x="179.413"
                    y="86.3316"
                    width="230"
                    height="58"
                    fill="#3FBF5A"
                  />
                </g>
                <rect
                  x="203.413"
                  y="144.332"
                  width="20"
                  height="20"
                  fill="#3FBF5A"
                />
                <rect
                  x="275.413"
                  y="144.332"
                  width="26"
                  height="14"
                  fill="#3FBF5A"
                />
                <rect
                  x="357.413"
                  y="144.332"
                  width="18"
                  height="22"
                  fill="#3FBF5A"
                />
                <rect
                  x="227.413"
                  y="196.332"
                  width="16"
                  height="16"
                  fill="#5A3D24"
                />
                <rect
                  x="339.413"
                  y="236.332"
                  width="18"
                  height="18"
                  fill="#7D5A3A"
                />
                <rect
                  x="267.413"
                  y="258.332"
                  width="14"
                  height="14"
                  fill="#523620"
                />
              </g>
              <g class="hero-cube" filter="url(#filter4_dii_3_211)">
                <rect
                  width="130"
                  height="130"
                  transform="translate(319.413 230.332)"
                  fill="#8A9096"
                />
                <rect
                  x="343.413"
                  y="252.332"
                  width="20"
                  height="20"
                  fill="#5FD9E0"
                />
                <rect
                  x="377.413"
                  y="298.332"
                  width="22"
                  height="22"
                  fill="#4FC7D4"
                />
                <rect
                  x="415.413"
                  y="260.332"
                  width="16"
                  height="16"
                  fill="#72E4EA"
                />
                <rect
                  x="339.413"
                  y="328.332"
                  width="16"
                  height="16"
                  fill="#4FC7D4"
                />
              </g>
              <g class="hero-tnt" filter="url(#filter5_dii_3_211)">
                <rect
                  width="84"
                  height="84"
                  transform="translate(121.413 302.332)"
                  fill="#C94436"
                />
                <rect
                  width="84"
                  height="24"
                  transform="translate(121.413 332.332)"
                  fill="#E8E2D4"
                />
                <path
                  d="M153.288 347.707V340.957H151.038V339.832H157.788V340.957H155.538V347.707H153.288ZM158.913 347.707V339.832H161.163V340.957H162.288V342.082H163.413V343.207H164.538V339.832H166.788V347.707H164.538V345.457H163.413V344.332H162.288V343.207H161.163V347.707H158.913ZM171.288 347.707V340.957H169.038V339.832H175.788V340.957H173.538V347.707H171.288Z"
                  fill="#C94436"
                />
              </g>
              <g class="green-cube" filter="url(#filter6_dii_3_211)">
                <rect
                  width="76.0014"
                  height="76.0014"
                  transform="translate(67.7707 32.3806)"
                  fill="#2FAE6B"
                />
                <g filter="url(#filter7_i_3_211)">
                  <rect
                    x="86.7707"
                    y="51.3813"
                    width="38.0014"
                    height="38"
                    fill="#4FD68C"
                  />
                </g>
              </g>
              <g class="grey-red" filter="url(#filter8_dii_3_211)">
                <rect
                  width="64.0012"
                  height="64.0012"
                  transform="translate(30 291.385)"
                  fill="#8A9096"
                />
                <rect
                  x="42"
                  y="303.385"
                  width="12"
                  height="12"
                  fill="#E2564B"
                />
                <rect
                  x="66"
                  y="329.385"
                  width="14"
                  height="14"
                  fill="#C93A30"
                />
                <rect x="75" y="325.385" width="9" height="9" fill="#E2564B" />
              </g>
              <g class="small-ground-block" filter="url(#filter9_dii_3_211)">
                <rect
                  width="68.0013"
                  height="68.0013"
                  transform="translate(480.028 59.3411)"
                  fill="#6B4A2F"
                />
                <rect
                  x="494.028"
                  y="71.3411"
                  width="11"
                  height="11"
                  fill="#523620"
                />
                <rect
                  x="523.028"
                  y="100.341"
                  width="13"
                  height="13"
                  fill="#7D5A3A"
                />
              </g>
              <g
                class="grey-blue-small-block"
                filter="url(#filter10_dii_3_211)"
              >
                <rect
                  width="80.0015"
                  height="80.0015"
                  transform="translate(424.867 427.228)"
                  fill="#8A9096"
                />
                <rect
                  x="440.867"
                  y="441.228"
                  width="14"
                  height="14"
                  fill="#3A66C9"
                />
                <rect
                  x="472.867"
                  y="475.228"
                  width="16"
                  height="16"
                  fill="#2B4A9E"
                />
                <rect
                  x="464.867"
                  y="469.228"
                  width="10"
                  height="10"
                  fill="#4A7AE2"
                />
              </g>
              <g class="small-yellow-block" filter="url(#filter11_ddii_3_211)">
                <rect
                  width="58.0011"
                  height="58.0011"
                  transform="translate(154.112 481.599)"
                  fill="#C99A2E"
                />
                <g filter="url(#filter12_i_3_211)">
                  <rect
                    x="168.112"
                    y="495.599"
                    width="30.0011"
                    height="30"
                    fill="#FFE27A"
                  />
                </g>
              </g>
              <defs>
                <filter
                  id="filter0_dii_3_211"
                  x="43.4128"
                  y="14.3316"
                  width="190"
                  height="190"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="20" />
                  <feGaussianBlur stdDeviation="20" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3_211"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_211"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="12" dy="12" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-12" dy="-12" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect2_innerShadow_3_211"
                    result="effect3_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter1_i_3_211"
                  x="109.413"
                  y="60.3316"
                  width="58"
                  height="58"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-8" dy="-8" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter2_dii_3_211"
                  x="119.413"
                  y="56.3316"
                  width="350"
                  height="350"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="30" />
                  <feGaussianBlur stdDeviation="30" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3_211"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_211"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="20" dy="20" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.09 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-20" dy="-20" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect2_innerShadow_3_211"
                    result="effect3_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter3_ii_3_211"
                  x="179.413"
                  y="86.3316"
                  width="230"
                  height="58"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="20" dy="8" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-20" dy="-14" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect1_innerShadow_3_211"
                    result="effect2_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter4_dii_3_211"
                  x="275.413"
                  y="208.332"
                  width="218"
                  height="218"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="22" />
                  <feGaussianBlur stdDeviation="22" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3_211"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_211"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="12" dy="12" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.14 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-12" dy="-12" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect2_innerShadow_3_211"
                    result="effect3_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter5_dii_3_211"
                  x="87.4128"
                  y="284.332"
                  width="152"
                  height="152"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="16" />
                  <feGaussianBlur stdDeviation="17" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3_211"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_211"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="9" dy="9" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-9" dy="-9" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect2_innerShadow_3_211"
                    result="effect3_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter6_dii_3_211"
                  x="33.7707"
                  y="14.3806"
                  width="144.001"
                  height="144.001"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="16" />
                  <feGaussianBlur stdDeviation="17" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3_211"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_211"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="9" dy="9" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-9" dy="-9" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect2_innerShadow_3_211"
                    result="effect3_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter7_i_3_211"
                  x="86.7707"
                  y="51.3813"
                  width="38.0014"
                  height="38"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-6" dy="-6" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter8_dii_3_211"
                  x="0"
                  y="275.385"
                  width="124.001"
                  height="124.001"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="14" />
                  <feGaussianBlur stdDeviation="15" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3_211"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_211"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="8" dy="8" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.13 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-8" dy="-8" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect2_innerShadow_3_211"
                    result="effect3_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter9_dii_3_211"
                  x="450.028"
                  y="43.3411"
                  width="128.001"
                  height="128.001"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="14" />
                  <feGaussianBlur stdDeviation="15" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3_211"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_211"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="8" dy="8" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-8" dy="-8" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect2_innerShadow_3_211"
                    result="effect3_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter10_dii_3_211"
                  x="386.867"
                  y="407.228"
                  width="156.001"
                  height="156.001"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="18" />
                  <feGaussianBlur stdDeviation="19" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3_211"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_211"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="9" dy="9" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.13 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect2_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-9" dy="-9" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect2_innerShadow_3_211"
                    result="effect3_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter11_ddii_3_211"
                  x="128.112"
                  y="455.599"
                  width="110.001"
                  height="122.001"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="12" />
                  <feGaussianBlur stdDeviation="13" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="13" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 0.886275 0 0 0 0 0.478431 0 0 0 0.35 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_3_211"
                    result="effect2_dropShadow_3_211"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_3_211"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="7" dy="7" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect3_innerShadow_3_211"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-7" dy="-7" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="effect3_innerShadow_3_211"
                    result="effect4_innerShadow_3_211"
                  />
                </filter>
                <filter
                  id="filter12_i_3_211"
                  x="168.112"
                  y="495.599"
                  width="30.0011"
                  height="30"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-5" dy="-5" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_3_211"
                  />
                </filter>
                <linearGradient
                  id="paint0_linear_3_211"
                  x1="56.9905"
                  y1="32.3806"
                  x2="531.829"
                  y2="507.219"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#21C17E" stop-opacity="0.32" />
                  <stop offset="1" stop-color="#21C17E" stop-opacity="0.04" />
                </linearGradient>
                <clipPath id="clip0_3_211">
                  <rect
                    width="474.839"
                    height="474.839"
                    fill="white"
                    transform="translate(56.9905 32.3806)"
                  />
                </clipPath>
                <clipPath id="clip1_3_211">
                  <rect
                    width="334.556"
                    height="334.556"
                    fill="white"
                    transform="translate(127.132 102.522)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>

      <div class="play">
        <div class="play__inner _cnt">
          <div class="play__methods methods">
            <div class="methods__title">
              {{ $t('ПРИНИМАЕМ К ОПЛАТЕ') }}
            </div>
            <div class="methods__items">
              <div class="methods__item">{{ $t('СБП') }}</div>
              <div class="methods__item">{{ $t('VISA') }}</div>
              <div class="methods__item">{{ $t('MC') }}</div>
              <div class="methods__item">{{ $t('МИР') }}</div>
            </div>
          </div>
          <div class="play__subtitle _subtitle">
            {{ $t('РЕЖИМЫ СЕРВЕРА') }}
          </div>
          <div class="play__title _h2">{{ $t('Выбери, как играть') }}</div>
          <div class="play__items">
            <div class="play__item">
              <div class="play__image _ibg">
                <img src="./../img/play-01.jpg" />
              </div>
              <div class="play__content">
                <div class="play__label _h3">{{ $t('Выживание') }}</div>
                <div class="play__value">
                  {{
                    $t(
                      'Классический режим: добывай ресурсы, отбивайся от мобов и строй убежище.',
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="play__item">
              <div class="play__image _ibg">
                <img src="./../img/play-02.jpg" />
              </div>
              <div class="play__content">
                <div class="play__label _h3">{{ $t('Креатив') }}</div>
                <div class="play__value">
                  {{
                    $t(
                      'Безлимитные блоки и полёт — для тех, кто пришёл строить, а не воевать.',
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="play__item">
              <div class="play__image _ibg">
                <img src="./../img/play-03.jpg" />
              </div>
              <div class="play__content">
                <div class="play__label _h3">{{ $t('Мини-игры') }}</div>
                <div class="play__value">
                  {{
                    $t(
                      'БедВарс, паркур и арены — быстрые матчи с друзьями между сессиями выживания.',
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rules">
        <div class="rules__inner _cnt">
          <div class="rules__subtitle _subtitle">
            {{ $t('НАШИ ПРАВИЛА ИГРЫ') }}
          </div>
          <div class="rules__title _h2">
            {{ $t('Играем по-честному') }}
          </div>
          <div class="rules__items">
            <div class="rules__item">
              <div class="rules__icon _ibg-contain">
                <img src="./../img/rules-01.svg" />
              </div>
              <div class="rules__label _h3">
                {{ $t('Без Pay-to-Win') }}
              </div>
              <div class="rules__value">
                {{
                  $t(
                    'Донат — это только внешний вид: скины, питомцы и эффекты. Преимущества в бою не продаются.',
                  )
                }}
              </div>
            </div>
            <div class="rules__item">
              <div class="rules__icon _ibg-contain">
                <img src="./../img/rules-02.svg" />
              </div>
              <div class="rules__label _h3">
                {{ $t('Сразу в инвентаре') }}
              </div>
              <div class="rules__value">
                {{
                  $t(
                    'Оплатил — и покупка уже у тебя в игре. Никаких ожиданий и ручной выдачи.',
                  )
                }}
              </div>
            </div>
            <div class="rules__item">
              <div class="rules__icon _ibg-contain">
                <img src="./../img/rules-03.svg" />
              </div>
              <div class="rules__label _h3">
                {{ $t('Безопасная оплата') }}
              </div>
              <div class="rules__value">
                {{
                  $t(
                    'СБП, Visa, MasterCard и МИР. Данные под защитой шифрования и reCAPTCHA.',
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <section v-if="popularProducts.length" class="featured-products">
        <div class="featured-products__inner _cnt">
          <div class="featured-products__header">
            <div>
              <div class="featured-products__subtitle _subtitle">
                {{ $t('ЛАВКА BLOXNEST') }}
              </div>

              <h2 class="featured-products__title _h2">
                {{ $t('Чаще всего берут это') }}
              </h2>
            </div>

            <button
              type="button"
              class="featured-products__link"
              @click="openShop"
            >
              <span>{{ $t('Вся лавка') }}</span>

              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M1 6.5H11"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />

                <path
                  d="M7 2.5L11 6.5L7 10.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="square"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>

          <div class="featured-products__grid">
            <article
              v-for="item in popularProducts"
              :key="item.id"
              class="featured-product"
            >
              <div class="featured-product__preview">
                <transition name="fade">
                  <div
                    v-if="addToCartChosenItem == item.id"
                    class="featured-product__added"
                  >
                    {{ $t('Добавлено') }}
                  </div>
                </transition>

                <img
                  :src="getProductImage(item)"
                  :alt="item.title"
                  class="featured-product__image"
                />
              </div>

              <div class="featured-product__content">
                <h3 class="featured-product__name" :title="item.title">
                  {{ item.title }}
                </h3>

                <div class="featured-product__bottom">
                  <div class="featured-product__price">
                    <span>{{ formatProductPrice(item.price) }}</span>

                    <span class="featured-product__currency">
                      {{ currency }}
                    </span>
                  </div>

                  <button
                    type="button"
                    class="featured-product__buy"
                    @click="handleFeaturedAddToCart(item, item.id)"
                  >
                    {{ $t('КУПИТЬ') }}
                  </button>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <div class="start">
        <div class="start__inner _cnt">
          <div class="start__content">
            <div class="start__bg _ibg">
              <img src="./../img/start-bg.png" />
            </div>
            <div class="start__title _h2">
              {{ $t('Первый кубик — за тобой') }}
            </div>
            <div class="start__text">
              {{
                $t(
                  'Регистрация занимает минуту. Заходи на сервер, выбирай биом и начинай своё приключение уже сегодня.',
                )
              }}
            </div>
            <button
              type="button"
              class="start__action button shadowed"
              @click="handleAccountAction"
            >
              {{ isAuth ? $t('ПЕРЕЙТИ В МАГАЗИН') : $t('СОЗДАТЬ АККАУНТ') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Home',

  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },

    serverIp: {
      type: String,
      default: '',
    },

    serverPort: {
      type: [String, Number],
      default: '',
    },

    isAuth: {
      type: Boolean,
      default: false,
    },

    currency: {
      type: String,
      default: '',
    },

    addToCartChosenItem: {
      type: [String, Number],
      default: '',
    },
  },

  data() {
    return {
      email: '',
      name: '',
      message: '',
      nickname: '',

      activePanels: [],

      ipCopied: false,
      copyTimeout: null,

      popularProducts: [],
      popularProductsLoading: false,

      imgDomain: '',
    }
  },

  computed: {
    gameServer() {
      return this.settings && this.settings.game_server
        ? this.settings.game_server
        : null
    },

    serverHost() {
      return (this.gameServer && this.gameServer.host) || this.serverIp || ''
    },

    serverPortValue() {
      return (this.gameServer && this.gameServer.port) || this.serverPort || ''
    },

    serverAddress() {
      if (!this.serverHost) {
        return ''
      }

      return this.serverPortValue
        ? `${this.serverHost}:${this.serverPortValue}`
        : this.serverHost
    },
  },

  watch: {
    currency: {
      immediate: true,

      handler(newCurrency, oldCurrency) {
        if (!newCurrency) {
          return
        }

        if (
          oldCurrency &&
          newCurrency === oldCurrency &&
          this.popularProducts.length
        ) {
          return
        }

        this.getPopularProducts()
      },
    },
  },

  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN || ''
  },

  beforeDestroy() {
    if (this.copyTimeout) {
      clearTimeout(this.copyTimeout)
      this.copyTimeout = null
    }
  },

  methods: {
    getPopularProducts() {
      if (this.popularProductsLoading) {
        return
      }

      this.popularProductsLoading = true

      const params = {
        type: 'new',
      }

      if (this.currency) {
        params.currency = this.currency
      }

      this.$http
        .get('products', {
          params,
        })
        .then((response) => {
          const payload =
            response && response.data && Array.isArray(response.data.payload)
              ? response.data.payload
              : []

          this.popularProducts = payload.slice(0, 4)
        })
        .catch((error) => {
          console.error(
            'Не удалось загрузить товары для главной страницы:',
            error,
          )

          this.popularProducts = []
        })
        .finally(() => {
          this.popularProductsLoading = false
        })
    },

    getProductImage(item) {
      if (!item || !item.image_url) {
        return ''
      }

      const imageUrl = String(item.image_url)

      if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl
      }

      const domain = String(this.imgDomain || '').replace(/\/+$/, '')

      const path = imageUrl.replace(/^\/+/, '')

      return domain ? `${domain}/${path}` : `/${path}`
    },

    formatProductPrice(price) {
      const value = Number(price)

      if (!Number.isFinite(value)) {
        return '0.00'
      }

      return value.toFixed(2)
    },

    handleFeaturedAddToCart(item, id) {
      if (!item || !id) {
        return
      }

      this.$emit('addToCart', item, id)
    },

    openShop() {
      if (this.$route.path === '/categories') {
        return
      }

      this.$router.push({
        path: '/categories',
      })
    },

    async copyIP() {
      if (!this.serverAddress) {
        return
      }

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.serverAddress)
        } else {
          this.copyTextFallback(this.serverAddress)
        }

        this.showCopiedStatus()
      } catch (error) {
        console.error('Не удалось скопировать адрес сервера:', error)
      }
    },

    copyTextFallback(text) {
      const textarea = document.createElement('textarea')

      textarea.value = text
      textarea.setAttribute('readonly', '')

      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      textarea.style.top = '0'
      textarea.style.opacity = '0'

      document.body.appendChild(textarea)

      textarea.focus()
      textarea.select()

      textarea.setSelectionRange(0, textarea.value.length)

      document.execCommand('copy')

      document.body.removeChild(textarea)
    },

    showCopiedStatus() {
      this.ipCopied = true

      if (this.copyTimeout) {
        clearTimeout(this.copyTimeout)
      }

      this.copyTimeout = setTimeout(() => {
        this.ipCopied = false
        this.copyTimeout = null
      }, 2000)
    },

    togglePanel(index) {
      const activeIndex = this.activePanels.indexOf(index)

      if (activeIndex !== -1) {
        this.activePanels.splice(activeIndex, 1)

        return
      }

      this.activePanels.push(index)
    },

    isActivePanel(index) {
      return this.activePanels.includes(index)
    },

    submit() {
      const data = {
        name: this.name.trim(),
        email: this.email.trim(),
        message: this.message.trim(),
      }

      this.$emit('sendContactForm', data)
    },

    playNow() {
      if (this.isAuth) {
        this.openShop()
        return
      }

      if (this.$parent && typeof this.$parent.openSignIn === 'function') {
        this.$parent.openSignIn()
      }
    },

    handleAccountAction() {
      if (this.isAuth) {
        this.openShop()
        return
      }

      this.$emit('open-sign-up')
    },
  },
}
</script>
<style lang="scss">
.hero {
  padding-top: 80px;
  padding-bottom: 150px;
  position: relative;
  @media (max-width: 991.98px) {
    padding-top: 50px;
    padding-bottom: 100px;
  }
  @media (max-width: 767.98px) {
    padding-top: 25px;
    padding-bottom: 50px;
  }
  &__bg {
    position: absolute !important;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
  }
  &__line {
    position: absolute !important;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: fit-content;
    padding-bottom: 5%;
    pointer-events: none;
  }
  &__inner {
    display: flex;
    gap: 40px;
    @media (max-width: 991.98px) {
      gap: 20px;
    }
  }
  &__content {
    align-self: center;
    flex: 0 1 53%;
    @media (max-width: 991.98px) {
      flex: 1 1 100%;
    }
  }
  &__image {
    @media (min-width: 991.98px) {
      flex: 0 1 47%;
      padding-bottom: 47%;
    }
    @media (max-width: 991.98px) {
      display: none;
    }
  }
  &__items {
    display: flex;
    gap: 13px;
    &:not(:last-child) {
      margin-bottom: 26px;
    }
    @media (max-width: 619.98px) {
      flex-wrap: wrap;
      gap: 10px;
      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }
  &__item {
    min-width: 32px;
    min-width: 113px;
    padding: 8px 16px;
    border: 1px solid var(--outer-space);
    background-color: var(--heavy-metal);
    color: var(--pewter);
    font-family: var(--font-3);
    font-size: 10px;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
  }

  &__box {
    min-width: 8px;
    height: 8px;
    background-color: var(--harvest-gold);
    &_green {
      background-color: var(--mountain-meadow);
    }
  }

  &__title {
    &:not(:last-child) {
      margin-bottom: 21px;
    }
    @media (max-width: 991.99px) {
      div {
        display: inline;
      }
    }
    @media (max-width: 767.98px) {
      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }

  &__text {
    font-size: 18px;
    line-height: 28.8px;
    color: var(--edward);
    font-family: var(--font-1);
    &:not(:last-child) {
      margin-bottom: 34px;
    }
    @media (min-width: 991.98px) {
      max-width: 500px;
    }
    @media (max-width: 767.98px) {
      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }

  &__actions {
    display: flex;
    gap: 16px;
    &:not(:last-child) {
      margin-bottom: 44px;
    }
    @media (max-width: 619.98px) {
      flex-wrap: wrap;
      gap: 10px;
      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }

  &__action {
    min-width: 234px;
    min-height: 53px;
    justify-content: center !important;
    &_first {
      font-family: var(--font-3) !important;
      font-size: 13px !important;
      text-transform: uppercase !important;
    }
  }

  &__stats {
    display: flex;
    gap: 110px;
    @media (max-width: 991.98px) {
      gap: 50px;
    }
    @media (max-width: 767.98px) {
      gap: 20px;
    }
    @media (max-width: 619.98px) {
      flex-wrap: wrap;
    }
  }

  &__stat {
  }

  &__label {
    font-family: var(--font-3);
    text-transform: uppercase;
    font-size: 19px;
    line-height: 19px;
    color: var(--harvest-gold);
    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
  &__value {
    font-size: 13px;
    line-height: 18px;
    color: var(--mantle);
  }
}

.green-cube {
  animation: 5s ease-in-out 0s infinite normal none running floatY;
}

.yellow-cube {
  animation: 8s ease-in-out 1s infinite normal none running floatY;
}

.ground-block {
  animation: 6s ease-in-out 0s infinite normal none running floatY;
}

.small-ground-block {
  animation: 6.5s ease-in-out 0.4s infinite normal none running floatY;
}

.hero-cube {
  animation: 6s ease-in-out 0s infinite normal none running floatY;
}

.hero-tnt {
  animation: 7s ease-in-out 0.5s infinite normal none running floatY;
}

.grey-red {
  animation: 7s ease-in-out 0.8s infinite normal none running floatY;
}

.small-yellow-block {
  animation: 7.4s ease-in-out 0.3s infinite normal none running floatY;
}

.grey-blue-small-block {
  animation: 5.6s ease-in-out 1.2s infinite normal none running floatY;
}

.green-bg-block {
  animation: 5s ease-in-out 0s infinite normal none running glowPulse;
}

@keyframes glowPulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.85;
  }
}

@keyframes floatY {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-14px);
  }
}

@keyframes heroCubeFloat {
  0%,
  100% {
    transform: translate3d(0, 0, 0) rotate(0deg);
  }

  25% {
    transform: translate3d(-6px, -10px, 0) rotate(-2deg);
  }

  50% {
    transform: translate3d(0, -18px, 0) rotate(1.5deg);
  }

  75% {
    transform: translate3d(6px, -8px, 0) rotate(2deg);
  }
}

.methods {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 26px;
  @media (max-width: 991.98px) {
    gap: 16px;
  }
  @media (max-width: 619.98px) {
    flex-direction: column;
    align-items: center;
  }
  &__title {
    white-space: nowrap;
    text-transform: uppercase;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.4px;
    color: var(--mantle);
  }

  &__items {
    display: flex;
    gap: 26px;
    @media (max-width: 991.98px) {
      gap: 16px;
    }
  }

  &__item {
    background-color: var(--heavy-metal);
    border-radius: 10px;
    min-height: 38px;
    min-width: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    border: 1px solid var(--outer-space);
    font-family: var(--font-2);
    color: var(--conch);
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    padding: 5px 10px;
  }
}

.play {
  padding-top: 23px;
  padding-bottom: 50px;
  &__inner {
  }

  &__methods {
    &:not(:last-child) {
      margin-bottom: 90px;
    }
    @media (max-width: 991.98px) {
      &:not(:last-child) {
        margin-bottom: 50px;
      }
    }
    @media (max-width: 767.98px) {
      &:not(:last-child) {
        margin-bottom: 30px;
      }
    }
  }

  &__subtitle {
    text-align: center;
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  &__title {
    text-align: center;
    &:not(:last-child) {
      margin-bottom: 48px;
    }
    @media (max-width: 767.98px) {
      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }

  &__items {
    display: flex;
    gap: 22px;
    @media (max-width: 991.98px) {
      gap: 20px;
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  &__item {
    flex: 0 1 33.333%;
    @media (max-width: 991.98px) {
      flex: 0 1 calc(50% - 10px);
    }
    @media (max-width: 619.98px) {
      flex: 1 1 100%;
    }
  }

  &__image {
    padding-bottom: 45%;
    @media (max-width: 991.98px) {
      padding-bottom: 50%;
    }
  }

  &__content {
    padding: 24px 30px;
    @media (max-width: 991.98px) {
      padding: 16px;
    }
  }

  &__label {
    &:not(:last-child) {
      margin-bottom: 7px;
    }
  }

  &__value {
    font-size: 14px;
    line-height: 22px;
    color: var(--pewter);
    font-weight: 400;
    font-family: var(--font-1);
  }
}

.rules {
  padding-bottom: 80px;
  @media (max-width: 991.98px) {
    padding-bottom: 60px;
  }
  &__inner {
  }

  &__subtitle {
    text-align: center;
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  &__title {
    text-align: center;
    &:not(:last-child) {
      margin-bottom: 48px;
    }
    @media (max-width: 767.98px) {
      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }

  &__items {
    display: flex;
    gap: 22px;
    @media (max-width: 991.98px) {
      gap: 20px;
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  &__item {
    flex: 0 1 33.333%;
    padding: 24px 30px;
    border-radius: 18px;
    border: 1px solid var(--heavy-metal);
    background: linear-gradient(0deg, #161d1a 0%, #161d1a 100%);
    @media (max-width: 991.98px) {
      padding: 16px;
      flex: 0 1 calc(50% - 10px);
    }
    @media (max-width: 619.98px) {
      flex: 1 1 100%;
    }
  }

  &__icon {
    width: 56px;
    height: 56px;
    margin-right: auto;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  &__label {
    &:not(:last-child) {
      margin-bottom: 7px;
    }
  }

  &__value {
    font-size: 14px;
    line-height: 22px;
    color: var(--pewter);
    font-weight: 400;
    font-family: var(--font-1);
  }
}

.featured-products {
  padding: 0cqmax 0 82px;

  @media (max-width: 991.98px) {
    padding: 0px 0 64px;
  }

  @media (max-width: 767.98px) {
    padding: 0px 0 25px;
  }

  &__inner {
    position: relative;
  }

  &__header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 24px;

    margin-bottom: 26px;
  }

  &__subtitle {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  &__title {
    margin: 0;
  }

  &__link {
    display: flex;
    align-items: center;
    gap: 8px;

    margin: 0 0 5px;
    padding: 6px 0;

    font-family: var(--font-1);
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;

    color: var(--mountain-meadow);
    background: transparent;

    svg {
      flex: 0 0 auto;
      transition: transform 0.25s ease;
    }

    @media (any-hover: hover) {
      &:hover {
        color: var(--gray-nurse);

        svg {
          transform: translateX(4px);
        }
      }
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 18px;
  }

  @media (max-width: 991.98px) {
    &__grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 619.98px) {
    &__header {
      align-items: flex-start;
      flex-direction: column;
      gap: 12px;
    }

    &__link {
      margin-bottom: 0;
    }

    &__grid {
      grid-template-columns: 1fr;
    }
  }
}

.featured-product {
  position: relative;
  min-width: 0;

  background: #141b18;
  border: 1px solid var(--outer-space);
  border-radius: 4px;

  overflow: hidden;

  box-shadow: 4px 4px 0 rgba(6, 8, 10, 0.55);

  transition: transform 0.25s ease, border-color 0.25s ease,
    box-shadow 0.25s ease;

  @media (any-hover: hover) {
    &:hover {
      transform: translateY(-3px);
      border-color: rgba(37, 194, 128, 0.42);
      box-shadow: 6px 6px 0 rgba(6, 8, 10, 0.62);

      .featured-product__image {
        transform: scale(1.07);
      }
    }
  }

  &__preview {
    position: relative;
    height: 144px;
    display: flex;
    align-items: center;
    justify-content: center;

    background: radial-gradient(
      circle at center,
      rgba(35, 64, 51, 0.62) 0%,
      rgba(18, 26, 22, 0.95) 68%
    );

    border-bottom: 1px solid var(--outer-space);

    overflow: hidden;

    box-shadow: inset 2px 2px 0 rgba(255, 255, 255, 0.025),
      inset -2px -2px 0 rgba(0, 0, 0, 0.4);
  }

  &__image {
    display: block;
    width: 92px;
    height: 92px;

    object-fit: contain;
    object-position: center;

    image-rendering: auto;

    filter: drop-shadow(0 8px 8px rgba(0, 0, 0, 0.35));

    transition: transform 0.3s ease;
  }

  &__added {
    position: absolute;
    inset: 0;
    z-index: 3;

    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 16px;
    line-height: 21px;
    font-family: var(--font-2);
    font-weight: 600;
    color: var(--gray-nurse);
    z-index: 3;
    text-shadow: 1px 1px 1px var(--heavy-metal);
  }

  &__content {
    padding: 14px 13px 13px;
  }

  &__name {
    display: block;
    min-width: 0;
    margin: 0 0 12px;
    text-transform: capitalize;
    font-family: var(--font-2);
    font-size: 16px;
    font-weight: 600;
    line-height: 21px;

    color: var(--gray-nurse);

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  &__price {
    min-width: 0;
    display: flex;
    align-items: baseline;
    gap: 4px;

    font-family: var(--font-3);
    font-size: 11px;
    font-weight: 700;
    line-height: 14px;

    color: var(--harvest-gold);
  }

  &__currency {
    font-size: 8px;
    line-height: 11px;
    text-transform: uppercase;
  }

  &__buy {
    flex: 0 0 auto;

    min-width: 75px;
    min-height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 6px 11px;

    font-family: var(--font-3);
    font-size: 9px;
    font-weight: 400;
    line-height: 9px;

    color: var(--mountain-meadow);
    background: rgba(18, 45, 35, 0.72);
    border: 1px solid var(--mountain-meadow);
    border-radius: 2px;

    box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.22),
      inset 0 1px 0 rgba(255, 255, 255, 0.07);

    transition: color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;

    @media (any-hover: hover) {
      &:hover {
        color: var(--racing-green);
        background: var(--mountain-meadow);
        transform: translateY(-1px);
      }
    }
  }

  @media (max-width: 991.98px) {
    &__preview {
      height: 160px;
    }

    &__image {
      width: 104px;
      height: 104px;
    }
  }

  @media (max-width: 619.98px) {
    &__preview {
      height: 180px;
    }

    &__image {
      width: 116px;
      height: 116px;
    }

    &__content {
      padding: 16px;
    }

    &__name {
      font-size: 14px;
      line-height: 19px;
    }

    &__buy {
      min-width: 88px;
      min-height: 32px;
    }
  }
}

.start {
  margin-bottom: 90px;

  @media (max-width: 991.98px) {
    margin-bottom: 50px;
  }
  @media (max-width: 767.98px) {
    margin-bottom: 25px;
  }
  @media (max-width: 619.98px) {
    margin-bottom: 0px;
  }
  &__content {
    position: relative;
    text-align: center;
    padding: 56px 0px;
    border-radius: 26px;
    overflow: hidden;
    border: 1px solid var(--outer-space);
    @media (max-width: 991.98px) {
      padding: 35px 0px;
      border-radius: 16px;
    }
    @media (max-width: 619.98px) {
      padding: 25px 0px;
    }
  }
  &__bg {
    position: absolute !important;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  &__title {
    &:not(:last-child) {
      margin-bottom: 14px;
    }
  }

  &__text {
    font-family: 17px;
    line-height: 23px;
    color: var(--edward);
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
    &:not(:last-child) {
      margin-bottom: 30px;
    }
    @media (max-width: 767.98px) {
      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }

  &__action {
    min-width: 260px;
    height: 49px;
    margin: 0 auto;
    font-family: var(--font-3) !important;
    font-size: 13px !important;
    text-transform: uppercase !important;
    justify-content: center !important;
  }
}
</style>
